import Axios, { AxiosResponse } from 'axios';
import type { SupportedLanguages } from '@/plugins/i18n';
import type * as ApiModel from './models.pleased';

/**
 * Shared HTTP client instance for all API requests
 * Configured with default headers for Pleased API
 */
export const httpClient = Axios.create({
  headers: {
    'pl-access-token': '',
    'brand-subdomain': '',
    'language': 'en',
  },
});

/**
 * Success response code from Pleased API
 */
export const SUCCESS_CODE = 10000;

export interface PleaseApiConfig {
  url?: string;
  brandCode?: string;
  token?: string;
  acceptLanguage?: SupportedLanguages | '*' | '';
}

/**
 * Conditionally set the none empty configurations.
 */
export function setConfig({ url = '', brandCode = '', token = '', acceptLanguage = '' }: PleaseApiConfig) {
  url && (httpClient.defaults.baseURL = url);
  brandCode && (httpClient.defaults.headers['brand-subdomain'] = brandCode);
  token && (httpClient.defaults.headers['pl-access-token'] = token);
  acceptLanguage && (httpClient.defaults.headers['language'] = acceptLanguage);
}

/**
 * Utility that throws error if an API error has occurred.
 * @param response The response from API
 */
export function throwIfError(response: AxiosResponse<ApiModel.ApiResponse<unknown>>) {
  if (response.data.code !== SUCCESS_CODE) {
    // Import dynamically to avoid circular dependency
    import('./error-logger').then(({ logErrorEvents }) => {
      logErrorEvents({
        event: 'API Error',
        message: response.data.message,
        url: response.config.url,
        code: response.data.code
      });
    });
    throw new Error(response.data.message);
  }
}
